// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MsUO","importantInfo":"styles_importantInfo__2jMj-"};